import { z } from 'zod';
import { TimestampLike, safeText } from './common.js';

export const LocationEntry = z.object({
  locationCode: z.number().int(),
  locationName: z.string().min(1),
  countryCode: z.string().length(2).optional(),
});
export type LocationEntry = z.infer<typeof LocationEntry>;

export const KeywordDoc = z.object({
  subjectId: z.string().min(1),
  clientId: z.string().min(1),
  keyword: safeText('Keyword', { max: 200 }),
  isPrimary: z.boolean().default(false),
  locations: z.array(LocationEntry).min(1),
  trackOrganic: z.literal(true).default(true),
  trackPAA: z.boolean().default(false),
  trackLLMMentions: z.boolean().default(false), // V2 flag
  isActive: z.boolean().default(true),
  createdAt: TimestampLike,
  lastPulledAt: TimestampLike.optional(),
  nextPullAt: TimestampLike.optional(),
  manualPullCooldownUntil: TimestampLike.optional(),
});
export type KeywordDoc = z.infer<typeof KeywordDoc>;
